import axios from "axios";

// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_BASE_URL = import.meta.env.VITE_COUNSELLOR_API_BASE_URL;


export const createAppointment = async (appointmentData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/appointments`, appointmentData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Returns { success: true, data: {...} }
    } catch (error) {
        console.error("Error creating appointment:", error.response?.data || error.message);
        throw error;
    }
};

export const listAppointments = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/appointments`, {
            params: { 
                user_id: userId,
                app_name: "echoShine"
            } 
        });
        return response.data;
    } catch (error) {
        console.error(" Error fetching appointments:", error);
        throw error;
    }
};

export const listViewAppointments = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/veiwappointments`);
        return response.data;
    } catch (error) {
        console.error("\u274c Error fetching view appointments:", error);
        throw error;
    }
};

export const deleteAppointment = async (appointmentId, data) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/appointments/${appointmentId}`, data, {
            headers: {
                'Content-Type': 'application/json',
                // Add auth header if needed
                // 'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to patch appointment:', error);
        throw error.response?.data || error;
    }
};

export const cancelAppointment = async (appointmentId, remark = '', triggeredBy = 'client') => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/appointments/${appointmentId}`, {
            status: 'cancelled',
            cancellation_remark: remark,
            cancellation_triggered_by: triggeredBy
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to cancel appointment:', error);
        throw error.response?.data || error;
    }
};
export const getAppointments = async ({
    userId,
    doctorId,
    date,
    status,
    appName,
}) => {
    try {
        const params = {};

        if (userId) {
            params.user_id = userId;
            params.app_name = appName;
        }

        if (doctorId) {
            params.dr_id = doctorId;
        }

        if (date) {
            params.date = date;
        }

        if (status) {
            params.status = status;
        }

        const response = await axios.get(`${API_BASE_URL}/appointments`, {
            params,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching appointments:", error);
        throw error;
    }
};